
<!-- 客户信息 -->
<template>
  <div>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page"
      :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen"
      @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad">
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail } from "./api";
import { searchTimeConfig } from "@/basic-common/util/common";
export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      option: {
        ...this.$store.state.publicOption,
        column: [
          {
            label: '货主',
            prop: 'custNo',
            type: 'select',
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            search: true, // 查询是否显示
            props: {
              label: 'deptName',
              value: 'id'
            },
          },
          {
            label: '货主简称',
            prop: 'shortName',
            overHidden: true, // 表格超出隐藏
          },
          {
            label: '检索码',
            prop: 'searchCode',
            overHidden: true, // 表格超出隐藏
          },
          {
            label: '货主等级',
            prop: 'custLevel',
            overHidden: true, // 表格超出隐藏
            type: 'select',
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=custLevel",
            dataType: "number",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
    }
  }
}
</script>
<style scoped lang="scss"></style>
